// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1VQL5","gfeWrapper":"CalendarEvent_gfeWrapper__24EVt"};